import * as React from "react";
import { Path, G, ClipPath, Defs, Rect } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const MNIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="MN" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#4C67E8"
        fillRule="evenodd"
        d="M4.8 0h6.4v12H4.8V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#C51918"
        fillRule="evenodd"
        d="M10.4 0H16v12h-5.6V0ZM0 0h6.4v12H0V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#F8D000"
        d="m2.978 10-.863-.534H3.95L2.978 10Zm-1.093-.012H1V5.702h.885v4.286Zm3.115 0h-.885V5.702H5v4.286ZM3.923 9.28H2.115v-.335h1.808v.335Zm-.885-2.311c.51 0 .924.4.924.895 0 .493-.414.894-.924.894s-.923-.4-.923-.894.414-.895.923-.895Zm.885-.186H2.115v-.335h1.808v.335Zm-.945-.51-.863-.534H3.95l-.971.535ZM4.02 4.61c-.003.024-.16.933-1.068.933s-.95-.91-.951-.933c.012.018.367.57 1.01.57s.998-.553 1.01-.57ZM3.02 3.615c.414 0 .75.326.75.727a.739.739 0 0 1-.75.727.739.739 0 0 1-.75-.727c0-.401.335-.727.75-.727Zm-.006-1.464c.018.051.062.093.135.169.12.122-.02.628.083.628.102 0 .096-.444.096-.458l.172.458s.014.495-.493.495c-.506 0-.44-.493-.44-.495l.24-.518v.518c0 .067.091-.066.091-.227 0-.16.109-.401.109-.401l.007-.17Zm-.007-.119c.012-.073.01.02.007.119a.22.22 0 0 1-.007-.119Z"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
